var app = (function ($) {
    "use strict";

    var $window = $(window),
        $html = $('html');

    function init() {
        //Initialize Plugins
        //$('.tab-to-accordion').each(function () {
        //    var $this = $(this);

        //    $this.on('show.bs.tab', function (e) {
        //        $this.find($(e.target).attr('href') + ' .collapse').collapse('show');
        //        e.stopPropagation();
        //    });

        //    $this.on('shown.bs.collapse', function (e) {
        //        var tabId = $(e.target).parent('.tab-pane').attr('aria-labelledby');
        //        $this.find('#' + tabId).tab('show');
        //        e.stopPropagation();
        //    });
        //});

        //$('.accordion.open-first').each(function () {
        //    if ($(this).children(".card").length > 1) {
        //        $(this).find(".card").eq(0).find('.collapsed').removeClass('.collapsed').attr("aria-expanded", "true");
        //        $(this).find(".card").eq(0).find('.collapse').addClass('show');
        //    }
        //});


        //var targetNodes = document.getElementsByClassName('form');
        //if (targetNodes.length > 0) {
        //    // Options for the observer (which mutations to observe)
        //    var config = { childList: true, subtree: true };

        //    var callback = function (mutationsList, observer) {
        //        $.each(mutationsList, function () {
        //            if (this.type === 'childList') {
        //                checkInputs();
        //            }
        //        });
        //    };

        //    // Create an observer instance linked to the callback function
        //    var observer = new MutationObserver(callback);

        //    // Start observing the target node for configured mutations
        //    $.each(targetNodes, function (i) {
        //        observer.observe(targetNodes[i], config);
        //    });
        //}

        //watchInputs();
    }

    //function watchInputs() {

    //    $('.form-group').each(function () {
    //        var $group = $(this);

    //        $group.on({
    //            'focus': function () {
    //                $group.addClass('form-group--filled form-group--focus');
    //            },
    //            'blur': function () {
    //                $group.removeClass('form-group--focus');

    //                if ($(this).val().trim() === "") {
    //                    $group.removeClass('form-group--filled');
    //                }
    //            }
    //        }, 'input, textarea');

    //        $group.on({
    //            'change': function () {
    //                $group.addClass('form-group--filled');
    //            }
    //        }, 'select');

    //    });

    //    //watch select
    //    $('.form-group .custom-select').each(function () {
    //        var $selectGroup = $(this);

    //        $selectGroup.on({
    //            'click, focus': function () {
    //                $(this).closest(".form-group").addClass('form-group--filled form-group--focus');
    //            }
    //        });
    //    });
    //}


    //function checkInputs() {
    //    $('.form-group').each(function () {
    //        var $group = $(this),
    //            $error = $group.find('.field-validation-error');

    //        $group.find('input, textarea, select').attr('aria-invalid', $error.length > 0 ? 'true' : 'false');


    //        $group.find('input, textarea').each(function () {
    //            var $this = $(this);

    //            if ($this.val()) {
    //                $group.addClass('form-group--filled');
    //            }
    //        });

    //        $group.find('select').each(function () {
    //            var $this = $(this);

    //            if ($this.prop('selectedIndex') !== 0) {
    //                $group.addClass('form-group--filled');
    //            }
    //        });
    //    });

    //    watchInputs();
    //}

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    return {
        init: init,
        $window: $window,
        $html: $html,
        //checkInputs: checkInputs,
        GetUrlParameter: GetUrlParameter
    };
})(jQuery);


$(function () {
    app.init();
});